import {
  requestFinancierAccountAttachmentDownload,
  requestFinancierPurposeAttachmentDownload,
} from 'utils/http/api/financier/purpose-of-loans';
import useModal from 'utils/modal/useModal';

export function useFinancierFinancingDetailPurposeOfFinancingListLogics() {
  const modal = useModal();

  const onClickDownloadAccountFile = async (e: any, purposeOfLoanId: number) => {
    e.preventDefault();
    try {
      await requestFinancierAccountAttachmentDownload(purposeOfLoanId);
    } catch (e) {
      modal.show(e);
    }
  };

  const onClickDownloadPurposeFile = async (e: any, purposeOfLoanId: number) => {
    e.preventDefault();
    try {
      await requestFinancierPurposeAttachmentDownload(purposeOfLoanId);
    } catch (e) {
      modal.show(e);
    }
  };

  return {
    onClickDownloadAccountFile,
    onClickDownloadPurposeFile,
  };
}
